import styled from '@emotion/styled';
import { type FlexProps, Flex } from 'antd';

export const File = styled(Flex)`
  border: 1px solid ${({ theme }) => theme.colors.strokeGrey};
  border-radius: 10px;
  padding: 12px 16px;
`;

export const Inner = styled(Flex)<FlexProps>`
  .ui-form-item {
    margin-bottom: 16px;
  }
`;

export const Wrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.bgGrayLight};
  border-radius: 10px;
  padding: 20px;
  margin-bottom: 16px;

  .ui-picker {
    width: 100%;
  }
`;
